<template>
  <div>
    <div class="display-flex justify-space-between align-center mb-4">
      <div class="display-flex align-center gap-8">
        <img
          src="../../assets/mobile/notification_2.png"
          :width="30"
          :height="30"
          class="rounded"
        />
        <span class="text-poppins-16 text-black font-weight-500">SALVA</span>
      </div>
      <div
        @click="$router.push({ name: 'NotificationMobile' })"
        class="text-inter-15 btn-cancel font-weight-400"
      >
        Cancel
      </div>
    </div>

    <div class="display-flex gap-8 mb-3">
      <img
        src="../../assets/mobile/notification_2.png"
        :width="30"
        :height="30"
        class="rounded"
      />
      <div class="message__from pa-3">
        <div class="text-poppins-14 font-weight-500 text-black">Origami</div>
        <div class="text-inter-14 text-gray-dark my-1">
          I’m down! Any ideas??
        </div>
        <div class="text-right text-poppins-12">11:35 AM</div>
      </div>
    </div>

    <div class="display-flex justify-end">
      <div class="message__to pa-3">
        <div class="text-poppins-14 font-weight-500 text-white">
          I can do 10 pair of them..
        </div>
        <div class="text-right text-poppins-12 text-white">1d</div>
      </div>
    </div>

    <div class="display-flex align-center gap-15 full-width message__input">
      <input type="text" class="full-width px-3" />
      <img
        src="../../assets/mobile/icon/send.svg"
        :width="35"
        :height="35"
        class="rounded"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.btn-cancel {
  color: rgba(76, 158, 235, 0.9) !important;
}

.message {
  &__from {
    border-radius: 6px;
    background: #f2f2f7;
  }
  &__to {
    border-radius: 6px;
    background: #007aff;
  }
  &__input {
    position: fixed;
    z-index: 5;
    bottom: 0px;
    left: 0px;
    height: 81px;
    padding: 20px;
    input {
      border-radius: 17.5px;
      border: 1px solid rgba(68, 76, 86, 0.11);
      background: rgba(248, 251, 253, 0.3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// messages.vue?0f69b68e